import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { debounceTime, filter, Observable, Subscription } from 'rxjs';
import { Site } from 'src/app/model/site';
import { AppState } from 'src/app/store/app.reducer';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, TreeNode } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { StandardDesignParameters, StandardMtmaLayout, StandardPageLayout, StandardTruncateString } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { convertDbStandartIcon, convertOldIcon, DeviceIcon } from 'src/app/conf/device-icons';
import { DevicesTree } from 'src/app/model/device-tree';
import { EDeviceModel } from 'src/app/conf/device-models';
// import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { User } from 'src/app/model/user';
import { Lang } from 'src/app/model/lang';
import { DEFAULT_LANG } from 'src/app/conf/languages';
import { TranslateService } from '@ngx-translate/core';
import { AppComponent } from 'src/app/app.component';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { selectCurrentLang, selectIsDraftMode, selectIsImpersMode, selectUser } from 'src/app/store/user/user.selector';
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';
import { selectDeviceVctAuxEdited, selectDeviceVctDeleted, selectDeviceVctFeatureEdited, selectDeviceVctMassiveSharing, selectDeviceVctModuleEdited, selectDeviceVctShared, selectVctInvitationsList, selectVctLoadingInvitations, selectVctLoadingList, selectVctPlantsList } from 'src/app/store/device-vct/device-vct.selector';
import { FeatureVct, ModuleVct, Plant, SettingVct } from 'src/app/model/device-vct/device-vct-implant';
import { DevicesVctFeatures, DevicesVctModules, DevicesVctSettings } from 'src/app/conf/devices-vct';
import { InvitationVct } from 'src/app/model/device-vct/device-vct-invitations';
import { ShareDeviceVctDialogComponent } from '../share-device-vct-dialog/share-device-vct.dialog.component';
import { EditDeviceVctDialogComponent } from '../edit-device-vct-dialog/edit-device-vct.dialog.component';
import { AuxConfigDeviceVctDialogComponent } from '../aux-config-device-vct-dialog/aux-config-device-vct.dialog.component';
import { EditUnitVctDialogComponent } from '../edit-unit-vct-dialog/edit-unit-vct.dialog.component';
import { EditOperatorsVctDialogComponent } from '../edit-operators-vct-dialog copy/edit-operators-vct.dialog.component';
import { EditIntercommunicatingVctDialogComponent } from '../edit-intercommunicating-vct-dialog/edit-intercommunicating-vct.dialog.component';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
	selector: 'app-devices-vct-list-edit',
	templateUrl: './devices-vct-list-edit.component.html',
	providers: [ConfirmationService, DialogService]
})

export class DevicesVctListEditComponent implements OnInit, OnDestroy {
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	plantsList$: Observable<Plant[] | undefined>;
	plantsListSub: Subscription | undefined;
	invitationList$: Observable<InvitationVct[] | undefined>;
	invitationListSub: Subscription | undefined;
	deviceVctShared$: Observable<boolean | undefined>;
	deviceVctSharedSub: Subscription;
	deviceVctDeleted$: Observable<boolean | undefined>;
	deviceVctDeletedSub: Subscription;
	deviceVctModuleEdited$: Observable<boolean | undefined>;
	deviceVctModuleEditedSub: Subscription;
	deviceVctFeatureEdited$: Observable<boolean | undefined>;
	deviceVctFeatureEditedSub: Subscription;
	deviceVctAuxEdited$: Observable<boolean | undefined>;
	deviceVctAuxEditedSub: Subscription;
	loadingList$: Observable<boolean | undefined>;
	loadingListSub: Subscription;
	loadingInvitations$: Observable<boolean | undefined>;
	loadingInvitationsSub: Subscription;
	loadingMassiveSharing$: Observable<boolean | undefined>;
	loadingMassiveSharingSub: Subscription;

	loadingInvitations = false;
	loadingList = false;
	loadingMassiveSharing = false;

	currentSite: Site;
	plantsList: Plant[];
	invitationList: InvitationVct[];

	devicesTree: DevicesTree;
	devices: TreeNode[] = [];
	virtualEnableScroll = false;
	private readonly MIN_ITEMS_VIRTUAL_SCROLL = 13;

	errorCount: number = 0;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;

	isImpersMode: boolean;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	isDraftMode: boolean;
	isDraftMode$: Observable<boolean | undefined>;
	isDraftModeSub: Subscription;

	ref: DynamicDialogRef | undefined;

	deviceFilters: FormGroup;
	filterSub: Subscription;

	site: Site;
	acceptButtonStyle: string;
	rejectButtonStyle: string;

	screenWidth: number;
	MIN_WIDTH_COL6 = StandardDesignParameters.MIN_WIDTH_COL6;
	LG_WIDTH = StandardDesignParameters.LG_WIDTH;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
		private router: Router,
		private route: ActivatedRoute,
		public app: AppComponent
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.deviceFilters = new FormGroup({
			'searchFilter': new FormControl(''),
			'assignFilter': new FormControl(true),
			'pendingFilter': new FormControl(true),
			'notAssignFilter': new FormControl(true),
			'filterWarning': new FormControl(false),
			'onlyUnit': new FormControl(false),
			// 'type': new FormControl(this.siteType[0].value),
		});
		this.subscribeAll();
		this.onResize();
		/*setTimeout(() => { TODO CHANGE
			this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Devices list' } }));
		}, 2000);*/
		this.filterSub = this.deviceFilters.valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			this.generateTreeNode();
		});
	}

	initSelectors(): void {
		this.site$ = this.store.select(selectCurrentSite);
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
		this.currentUser$ = this.store.select(selectUser);
		this.isDraftMode$ = this.store.select(selectIsDraftMode);
		this.plantsList$ = this.store.select(selectVctPlantsList);
		this.invitationList$ = this.store.select(selectVctInvitationsList);
		this.deviceVctDeleted$ = this.store.select(selectDeviceVctDeleted);
		this.deviceVctShared$ = this.store.select(selectDeviceVctShared);
		this.deviceVctModuleEdited$ = this.store.select(selectDeviceVctModuleEdited);
		this.deviceVctFeatureEdited$ = this.store.select(selectDeviceVctFeatureEdited);
		this.deviceVctAuxEdited$ = this.store.select(selectDeviceVctAuxEdited);
		this.loadingList$ = this.store.select(selectVctLoadingList);
		this.loadingInvitations$ = this.store.select(selectVctLoadingInvitations);
		this.loadingMassiveSharing$ = this.store.select(selectDeviceVctMassiveSharing);
	}

	subscribeAll(): void {
		this.plantsListSub = this.plantsList$?.subscribe(plantsList => {
			this.plantsList = plantsList;
			this.generateTreeNode();
		});
		this.siteSub = this.site$?.pipe(
			filter(cs => !!cs)
		).subscribe((currentSite) => {
			this.site = currentSite;
		});
		this.currentLang$?.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.currentUserSub = this.currentUser$?.subscribe(
			(currentUser) => {
				this.currentUser = currentUser;
			}
		);
		this.isDraftModeSub = this.isDraftMode$.subscribe(
			(isDraftMode) => {
				this.isDraftMode = isDraftMode;
			}
		);
		this.siteSub = this.site$?.pipe(filter(currentSite => !!currentSite))
			.subscribe(currentSite => {
				this.currentSite = currentSite;
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		);
		this.invitationListSub = this.invitationList$.subscribe(
			(invitationList) => {
				this.invitationList = invitationList;
			}
		);
		this.deviceVctSharedSub = this.deviceVctShared$.subscribe((shared) => {
			if (shared) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		});
		this.deviceVctDeletedSub = this.deviceVctDeleted$.subscribe((deleted) => {
			if (deleted) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		});
		this.deviceVctModuleEditedSub = this.deviceVctModuleEdited$.subscribe((edited) => {
			if (edited) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		});
		this.deviceVctFeatureEditedSub = this.deviceVctFeatureEdited$.subscribe((edited) => {
			if (edited) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		});
		this.deviceVctAuxEditedSub = this.deviceVctAuxEdited$.subscribe((edited) => {
			if (edited) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		});
		this.loadingListSub = this.loadingList$.subscribe((loadingList) => {
			this.loadingList = loadingList;
		});
		this.loadingInvitationsSub = this.loadingInvitations$.subscribe((loadingInvitations) => {
			this.loadingInvitations = loadingInvitations;
		});
		this.loadingMassiveSharingSub = this.loadingMassiveSharing$.subscribe((loadingMassiveSharing) => {
			this.loadingMassiveSharing = loadingMassiveSharing;
		});
	}

	ngOnDestroy(): void {
		this.store.dispatch(NotificationsActions.resetTopbarTitleId());
		this.siteSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
		this.isDraftModeSub?.unsubscribe();
		this.invitationListSub?.unsubscribe();
		this.deviceVctModuleEditedSub?.unsubscribe();
		this.deviceVctFeatureEditedSub?.unsubscribe();
		this.plantsListSub?.unsubscribe();
		this.deviceVctAuxEditedSub?.unsubscribe();
		this.loadingListSub?.unsubscribe();
		this.loadingInvitationsSub?.unsubscribe();
		this.loadingMassiveSharingSub?.unsubscribe();
	}

	refreshData(): void {
		this.store.dispatch(DeviceVctActions.getDevicesVctList());
		this.store.dispatch(DeviceVctActions.getVctInvitations());
	}

	generateIcon(device: DevicesTree): string {
		let icon = '';
		if (device.ModelId !== EDeviceModel.MultiIO) {
			icon = 'cm-' + DeviceIcon[device.ModelId];
		} else {
			icon = 'cm-' + device.IconName.toLowerCase() || 'cm-' + DeviceIcon[device.ModelId] || 'cm-device-gateway';
		}
		switch (icon) {
			case 'cm-undefined': {
				return convertDbStandartIcon(device.IconName);
			}
			default: {
				return convertOldIcon(icon);
			}
		}
		return icon;
	}

	generateTreeNode(): void {
		this.devices = [];
		for (const dev of this.plantsList) {
			this.devices.push(this.createTreeNode(dev));
		}
	}

	createTreeNode(device: Plant): TreeNode {
		const onlyUnit = this.f.onlyUnit.value;
		let tree = {};
		if (device !== undefined && device.Id) {
			const mainChild = [];
			const unitList = [];
			for (const module of device.Modules) {
				const appList = [];
				if (module.Features !== undefined && module.Features.length > 0 && this.isAccessFeatureModule(module) && !onlyUnit) {
					for (const feature of module.Features) {
						if (feature.FeatureId === DevicesVctFeatures.App && this.checkMailStatusApp(feature) &&
							(this.checkNameFilter(feature) || this.checkNameFilter(module) ||
								this.checkMailAssignApp(feature) || this.checkMailAssignUnit(module) ||
								this.checkMailPendingApp(feature) || this.checkMailPendingUnit(module)) && this.checkWarningData(feature)) {
							let email = feature.SipAccount.UserEmail;
							if (this.isFeatureApp(feature) && this.isAssignAppPending(feature) && this.getInvitationPendingFeature(feature.Id)) {
								email = this.getInvitationPendingFeature(feature.Id).Email;
							}
							feature.SipAccount.UserEmail = email;
							if (feature.WarningError === undefined || feature.WarningError === null) {
								feature.WarningError = false;
							}
							appList.push({ label: 'NO_DEVICES', data: feature, icon: "pi cm-devices", children: [], expanded: true });
						}
					}
				}
				if (module.ModuleId === DevicesVctModules.VideoUnit && ((this.checkMailStatusUnit(module) &&
					(this.checkNameFilter(module) || this.checkMailAssignUnit(module) ||
						this.checkMailPendingUnit(module)) && this.checkWarningData(module)) || appList.length > 0)) {
					if (this.isModuleAssignPending(module) && this.getInvitationPendingModule(module.Id)) {
						module.OwnerEmail = this.getInvitationPendingModule(module.Id).Email;
					}
					if (module.WarningError === undefined || module.WarningError === null) {
						module.WarningError = false;
					}
					unitList.push({ label: 'NO_DEVICES', data: module, icon: "pi cm-derivate", children: appList, expanded: true });
				}
				/*if (module.ModuleId === DevicesVctModules.Targa && this.checkNameFilter(module)) {
					targa.push({ label: 'NO_DEVICES', data: module, icon: "pi cm-plate", children: [], expanded: true });
				}*/
			}
			if (unitList.length > 0) {
				mainChild.push({ label: 'NO_DEVICES', data: { Name: this.translate.instant('LIST_UNIT') }, icon: "pi cm-derivate", children: unitList, expanded: true });
			}
			/*if (targa.length > 0) {
				mainChild.push({ label: 'NO_DEVICES', data: { Name: this.translate.instant('LIST_OPERATORS') }, icon: "pi cm-plate", children: targa, expanded: true });
			}*/
			tree = { label: 'NO_DEVICES', data: device, icon: "pi cm-folder-trunk", children: mainChild, expanded: true };
		}
		return tree;
	}

	//----------------FILTER--------------------------------
	checkNameFilter(elem: any): boolean {
		const nameFilter = this.f.searchFilter.value;
		if (nameFilter === undefined || nameFilter === '') {
			return true;
		}
		if (elem.AliasName !== undefined && elem.AliasName !== '' && elem.AliasName.toLowerCase().includes(nameFilter.toLowerCase())) {
			return true;
		}
		if ((elem.AliasName === undefined || elem.AliasName === '') && elem.Name !== undefined && elem.Name !== '' && elem.Name.toLowerCase().includes(nameFilter.toLowerCase())) {
			return true;
		}
		nameFilter
		return false;
	}

	checkMailAssignApp(elem: any): boolean {
		const mailFilter = this.f.searchFilter.value;
		if (mailFilter === undefined || mailFilter === '') {
			return true;
		}
		if (elem.SipAccount !== undefined && elem.SipAccount.UserEmail !== undefined &&
			elem.SipAccount.UserEmail !== '' && elem.SipAccount.UserEmail.toLowerCase().includes(mailFilter.toLowerCase())) {
			return true;
		}
		return false;
	}

	checkMailAssignUnit(elem: any): boolean {
		const mailFilter = this.f.searchFilter.value;
		if (mailFilter === undefined || mailFilter === '') {
			return true;
		}
		if (elem.OwnerEmail !== undefined && elem.OwnerEmail !== '' && elem.OwnerEmail.toLowerCase().includes(mailFilter.toLowerCase())) {
			return true;
		}
		return false;
	}

	checkMailPendingApp(elem: any): boolean {
		const mailFilter = this.f.searchFilter.value;
		if (mailFilter === undefined || mailFilter === '') {
			return true;
		}
		const invitationPending = this.getInvitationPendingFeature(elem.Id);
		if (invitationPending !== undefined && invitationPending.Email !== undefined && invitationPending.Email !== '' &&
			invitationPending.Email.toLowerCase().includes(mailFilter.toLowerCase())) {
			return true;
		}
		return false;
	}

	checkMailPendingUnit(elem: any): boolean {
		const mailFilter = this.f.searchFilter.value;
		if (mailFilter === undefined || mailFilter === '') {
			return true;
		}

		const invitationPending = this.getInvitationPendingModule(elem.Id);
		if (invitationPending !== undefined && invitationPending.Email !== undefined && invitationPending.Email !== '' &&
			invitationPending.Email.toLowerCase().includes(mailFilter.toLowerCase())) {
			return true;
		}
		return false;
	}

	checkMailStatusUnit(elem: any): boolean {
		const assignFilter = this.f.assignFilter.value;
		const pendingFilter = this.f.pendingFilter.value;
		const notAssignFilter = this.f.notAssignFilter.value;
		if (assignFilter && pendingFilter && notAssignFilter) {
			return true;
		}
		if (assignFilter && this.isAssignModulePlant(elem)) {
			return true;
		}
		if (pendingFilter && this.isModuleAssignPending(elem)) {
			return true;
		}
		if (notAssignFilter && this.isNotAssign(elem) && !this.isModuleAssignPending(elem)) {
			return true;
		}
		return false;
	}

	checkMailStatusApp(elem: any): boolean {
		const assignFilter = this.f.assignFilter.value;
		const pendingFilter = this.f.pendingFilter.value;
		const notAssignFilter = this.f.notAssignFilter.value;
		if (assignFilter && pendingFilter && notAssignFilter) {
			return true;
		}
		if (assignFilter && this.isAssignApp(elem)) {
			return true;
		}
		if (pendingFilter && this.isAssignAppPending(elem)) {
			return true;
		}
		if (notAssignFilter && this.isNotAssignApp(elem) && !this.isAssignAppPending(elem)) {
			return true;
		}
		return false;
	}

	checkWarningData(elem: any): boolean {
		const filterWarning = this.f.filterWarning.value;
		if (!filterWarning) {
			return true;
		}
		if (filterWarning && elem.WarningError) {
			return true;
		}
		return false;
	}
	//----------------FILTER--------------------------------

	onDeviceExpand(event: any) {
		if (event !== undefined && event.node !== undefined && event.node.data !== undefined && event.node.data.Expand !== undefined) {
			event.node.data.Expand = true;
		}
	}

	onDeviceCollapse(event: any) {
		if (event !== undefined && event.node !== undefined && event.node.data !== undefined && event.node.data.Expand !== undefined) {
			event.node.data.Expand = false;
		}
	}

	updateScrollState(): void {
		this.virtualEnableScroll = this.treeTableVirtualScrollEnabled();
	}

	// count how many visibile row node we have on treeTable
	treeTableVirtualScrollEnabled(): boolean {
		let countCurrentViewNodes = 0;

		const visit = (nodes: any[]): boolean => {
			for (const node of nodes) {
				// ogni nodo visitato è una riga visibile
				countCurrentViewNodes++;
				if (countCurrentViewNodes >= this.MIN_ITEMS_VIRTUAL_SCROLL) {
					return true; // break and return
				}

				// visit node if is expanded true and has childrens
				if (node.expanded && node.children?.length) {
					if (visit(node.children)) {
						return true;
					}
				}
			}
			return false;
		};

		visit(this.devices);
		return countCurrentViewNodes >= this.MIN_ITEMS_VIRTUAL_SCROLL;
	}

	getRowInfo(data: any): string {
		if (data !== undefined && data.ProductId !== undefined) {
			return this.translate.instant('KEYCODE') + ': ' + data.Keycode;
		} else if (data !== undefined && data.FeatureId !== undefined &&
			data.FeatureId === DevicesVctFeatures.App && this.getSipAccountAppSettings(data) !== undefined) {
			return this.translate.instant('SIP_ACCOUNT') + ': ' + this.getSipAccountAppSettings(data).Value;
		}
		return '';
	}

	//--------------------CHECK CONTROL------------------------------------------------
	isModuleTarga(module: ModuleVct): boolean {
		if (module !== undefined && module.ModuleId !== undefined && module.ModuleId === DevicesVctModules.Targa) {
			return true;
		}
		return false;
	}
	isModifyMail(data: any): boolean {
		if (data !== undefined && ((data.ModuleId !== undefined && data.ModuleId === DevicesVctModules.VideoUnit) || data.FeatureId !== undefined)) {
			return true;
		}
		return false;
	}
	isFeatureApp(feature: any): boolean {
		if (feature !== undefined && feature.FeatureId !== undefined && feature.FeatureId === DevicesVctFeatures.App) {
			return true;
		}
		return false;
	}
	isAssignAppPending(feature: FeatureVct): boolean {
		if (this.isFeatureApp(feature) && this.getInvitationPendingFeature(feature.Id)) {
			return true;
		}
		return false;
	}
	isNotAssignApp(feature: any): boolean {
		if (feature !== undefined && feature.FeatureId !== undefined && feature.FeatureId === DevicesVctFeatures.App && !this.isAssignApp(feature) && !this.isAssignAppPending(feature)) {
			return true;
		}
		return false;
	}
	isAccessFeatureModule(module: ModuleVct): boolean {
		if (this.isAssignOwner(module)) {
			return true;
		}
		if (this.isModuleAssignPendingClient(module)) {
			return false;
		}
		if (this.isModuleAssignPending(module)) {
			return true;
		}
		if (this.isNotAssign(module)) {
			return true;
		}
		return false;
	}
	isAssignAppOwner(feature: any): boolean {
		if (feature !== undefined && feature.FeatureId !== undefined &&
			feature.FeatureId === DevicesVctFeatures.App &&
			this.currentUser !== undefined && this.currentUser.Email !== undefined && feature.SipAccount.UserEmail === this.currentUser.Email) {
			return true;
		}
		return false;
	}
	isAssignApp(feature: any): boolean {
		if (feature !== undefined && feature.FeatureId !== undefined && feature.FeatureId === DevicesVctFeatures.App &&
			feature.SipAccount.UserId !== undefined && feature.SipAccount.UserId !== null) {
			return true;
		}
		return false;
	}
	isAssignModulePlant(plant: any): boolean {
		if (plant !== undefined && plant.OwnerId !== undefined && plant.OwnerId !== null) {
			return true;
		}
		return false;
	}
	isOwner(plant: Plant): boolean {
		if (plant !== undefined) {
			if (this.currentUser.Id === plant.OwnerId) {
				return true;
			}
		}
		return false;
	}
	isOwnerById(id: number): boolean {
		if (id !== undefined) {
			if (this.currentUser.Id === id) {
				return true;
			}
		}
		return false;
	}
	isNotAssign(plant: any): boolean {
		if (plant !== undefined && (plant.OwnerEmail === undefined || plant.OwnerId === null)) {
			return true;
		}
		return false;
	}
	isAssignOwner(plant: any): boolean {
		if (plant !== undefined && plant.OwnerEmail !== undefined &&
			this.currentUser !== undefined && plant.OwnerEmail === this.currentUser.Email) {
			return true;
		}
		return false;
	}
	isAssignClient(plant: Plant): boolean {
		if (plant !== undefined && plant.OwnerEmail !== undefined && plant.OwnerEmail !== '' && !this.isOwner(plant)) {
			return true;
		}
		return false;
	}
	isModuleAssignPending(module: ModuleVct): boolean {
		if (module !== undefined && module.ModuleId !== undefined && this.getInvitationPendingModule(module.Id) !== undefined) {
			return true;
		}
		return false;
	}
	isModuleAssignPendingClient(module: ModuleVct): boolean {
		if (module !== undefined && module.ModuleId !== undefined &&
			this.getInvitationPendingModule(module.Id) !== undefined && this.currentUser !== undefined && this.currentUser.Email !== undefined &&
			this.getInvitationPendingModule(module.Id).Email !== this.currentUser.Email) {
			return true;
		}
		return false;
	}
	//--------------------CHECK CONTROL------------------------------------------------

	getInvitationPendingProduct(productId: number): InvitationVct {
		if (productId !== undefined && this.invitationList !== undefined && this.invitationList.length > 0) {
			return this.invitationList.find(inv => inv.SiteproductId !== undefined && inv.SiteproductId === productId &&
				inv.Rejected === null && inv.Accepted === null);
		}
		return undefined;
	}
	getInvitationPendingModule(moduleId: number): InvitationVct {
		if (moduleId !== undefined && this.invitationList !== undefined && this.invitationList.length > 0) {
			return this.invitationList.find(inv => inv.SitemoduleId !== undefined && inv.SitemoduleId === moduleId &&
				inv.Rejected === null && inv.Accepted === null);
		}
		return undefined;
	}
	getInvitationPendingFeature(featureId: number): InvitationVct {
		if (featureId !== undefined && this.invitationList !== undefined && this.invitationList.length > 0) {
			return this.invitationList.find(inv => inv.SitefeatureId !== undefined && inv.SitefeatureId === featureId &&
				inv.Rejected === null && inv.Accepted === null);
		}
		return undefined;
	}

	shareVisible(data: any): boolean {
		if (data !== undefined && data.ModuleId === undefined && data.FeatureId === undefined && data.ProductId === undefined) {
			return false;
		}
		if (!this.isModuleTarga(data) && this.isNotAssign(data) && !this.isModuleAssignPending(data)) {
			return true;
		} else if (data !== undefined && data.FeatureId !== undefined) {
			return true;
		}
		return false;
	}

	editVisible(data: any): boolean {
		if (data !== undefined && data.ProductId !== undefined) {
			return true;
		} else if (data !== undefined && data.ModuleId !== undefined) {
			return true;
		} else if (data !== undefined && data.FeatureId !== undefined) {
			return true;
		}
		return false;
	}

	//----------------------DIALOG ACTION-----------------------------
	shareDevice(data: any): void {
		if (data !== undefined && data.ProductId !== undefined) {
			this.shareDeviceProduct(data.Id);
		}
		if (data !== undefined && data.ModuleId !== undefined) {
			this.shareDeviceModule(data.Id);
		}
	}
	shareDeviceProduct(productId: number): void {
		this.store.dispatch(DeviceVctActions.createVctInvitationsReset());
		this.ref = this.dialogService.open(ShareDeviceVctDialogComponent, {
			header: this.translate.instant('SHARE'),
			width: '70vw',
			breakpoints: { '1600px': '95vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				productId: productId
			},
		});
	}
	shareDeviceModule(moduleId: number): void {
		this.store.dispatch(DeviceVctActions.createVctInvitationsReset());
		this.ref = this.dialogService.open(ShareDeviceVctDialogComponent, {
			header: this.translate.instant('SHARE') + ' ' + this.translate.instant('UNIT').toLowerCase(),
			width: '70vw',
			breakpoints: { '1600px': '95vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				moduleId: moduleId
			},
		});
	}

	assignToMe(data: any): void {
		if (data !== undefined && !this.isFeatureApp(data)) {
			data.OwnerEmail = this.currentUser.Email;
		} else if (data !== undefined && this.isFeatureApp(data)) {
			data.SipAccount.UserEmail = this.currentUser.Email;
		}
	}
	removeEmail(data: any): void {
		if (data !== undefined && !this.isFeatureApp(data)) {
			data.OwnerEmail = '';
		} else if (data !== undefined && this.isFeatureApp(data)) {
			data.SipAccount.UserEmail = '';
		}
	}
	revokeDevice(data: any): void {
		if (data !== undefined && data.ProductId !== undefined) {
			const invitation = this.getInvitationPendingProduct(data.Id);
			if (invitation !== undefined) {
				this.revokeInvitation(invitation);
			}
		}
		if (data !== undefined && data.ModuleId !== undefined) {
			const invitation = this.getInvitationPendingModule(data.Id);
			if (invitation !== undefined) {
				this.revokeInvitation(invitation);
			}
		}
		if (data !== undefined && data.FeatureId !== undefined) {
			const invitation = this.getInvitationPendingFeature(data.Id);
			if (invitation !== undefined) {
				this.revokeInvitation(invitation);
			}
		}
	}
	revokeInvitation(invitation: InvitationVct) {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('REVOKE_INVITATION'),
			message: this.translate.instant('REVOKE_INVITATION_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceVctActions.removeVctInvitations({ invitationId: invitation.Token }));
			},
			reject: () => {
			}
		});
	}
	configAuxiliatyCommands(data: any): void {
		if (data !== undefined && data.ModuleId !== undefined && data.ModuleId === DevicesVctModules.Targa) {
			this.store.dispatch(DeviceVctActions.editVctModuleNameReset());
			this.ref = this.dialogService.open(AuxConfigDeviceVctDialogComponent, {
				header: this.translate.instant('EDIT_DEVICE'),
				width: '70vw',
				breakpoints: { '1600px': '98vw' },
				contentStyle: { overflow: 'auto' },
				data: {
					moduleId: data.Id,
				},
			});
		}
	}
	editDeviceName(data: any): void {
		if (data !== undefined && data.ProductId !== undefined) {

			this.editPlant(data);
		}
		if (data !== undefined && data.ModuleId !== undefined && data.ModuleId !== DevicesVctModules.Targa) {

			this.editModuleUnitName(data);
		}
		if (data !== undefined && data.ModuleId !== undefined && data.ModuleId !== DevicesVctModules.VideoUnit) {

			this.editModuleOperatorsName(data);
		}
		if (data !== undefined && data.FeatureId !== undefined) {
			let name = data.Name;
			if (data.AliasName !== '') {
				name = data.AliasName;
			}
			this.editFeatureName(data.Id, name);
		}
		if (data !== undefined && data.FeatureId !== undefined) {
			let name = data.Name;
			if (data.AliasName !== '') {
				name = data.AliasName;
			}
			this.editFeatureName(data.Id, name);
		}
	}
	editPlant(device: Plant): void {
		if (device !== undefined && device.Id) {
			for (const module of device.Modules) {
				if (module.ModuleId === DevicesVctModules.Building) {
					this.editIntercommunicationgName(module);
					break;
				}
			}
		}
	}
	editIntercommunicationgName(module: ModuleVct): void {
		this.store.dispatch(DeviceVctActions.editVctModuleNameReset());
		this.ref = this.dialogService.open(EditIntercommunicatingVctDialogComponent, {
			header: this.translate.instant('EDIT_DEVICE'),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module,
			},
		});
	}
	editModuleUnitName(module: ModuleVct): void {
		this.store.dispatch(DeviceVctActions.editVctModuleNameReset());
		this.ref = this.dialogService.open(EditUnitVctDialogComponent, {
			header: this.translate.instant('EDIT_DEVICE'),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module,
			},
		});
	}
	editModuleOperatorsName(module: ModuleVct): void {
		this.store.dispatch(DeviceVctActions.editVctModuleNameReset());
		this.ref = this.dialogService.open(EditOperatorsVctDialogComponent, {
			header: this.translate.instant('EDIT_DEVICE'),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module,
			},
		});
	}
	editFeatureName(featureId: number, name: string): void {
		this.store.dispatch(DeviceVctActions.editVctFeatureNameReset());
		this.ref = this.dialogService.open(EditDeviceVctDialogComponent, {
			header: this.translate.instant('EDIT_DEVICE'),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				featureId: featureId,
				name: name
			},
		});
	}
	//----------------------DIALOG ACTION-----------------------------

	getSipAccountAppSettings(feature: FeatureVct): SettingVct {
		if (feature !== undefined && feature.FeatureId === DevicesVctFeatures.App && feature.Settings !== undefined && feature.Settings.length > 0) {
			for (const setting of feature.Settings) {
				if (setting.SettingId === DevicesVctSettings.SipAccount1) {
					return setting;
				}
			}
		}
		return undefined;
	}

	/*getAssignSipAccountApp(feature: FeatureVct): SipAccountVct {
		if (feature !== undefined && feature.FeatureId === DevicesVctFeatures.App && feature.Settings !== undefined && feature.Settings.length > 0) {
			for (const setting of feature.Settings) {
				if (setting.SettingId === DevicesVctSettings.SipAccount1) {
					const sipAccount = this.getSipAccount(setting.Value);
					if (sipAccount !== undefined && sipAccount !== null && sipAccount.UserEmail !== undefined && sipAccount.UserEmail !== '') {
						return sipAccount;
					}
				}
			}
		}
		return undefined;
	}*/

	/*isAssignSipAccountApp(feature: FeatureVct): boolean {
		if (feature !== undefined && feature.FeatureId === DevicesVctFeatures.App && feature.Settings !== undefined && feature.Settings.length > 0) {
			for (const setting of feature.Settings) {
				if (setting.SettingId === DevicesVctSettings.SipAccount1) {
					const sipAccount = this.getSipAccount(setting.Value);
					if (sipAccount !== undefined && sipAccount !== null && sipAccount.UserEmail !== undefined && sipAccount.UserEmail !== '') {
						return true;
					}
				}
			}
		}
		return false;
	}*/


	/*getSipAccount(sipUser: string): SipAccountVct {
		for (const device of this.plantsList) {
			if (device !== undefined && device.Id) {
				for (const module of device.Modules) {
					if (module.SipAccounts !== undefined && module.SipAccounts.length > 0) {
						for (const feature of module.SipAccounts) {
							if (feature.SipUsername === sipUser) {
								return feature;
							}
						}
					}
				}
			}
		}
		return undefined;
	}*/

	checkDataWarningError(data: any) {
		if (data?.WarningError === true) {
			this.errorCount++;
		}
	}

	updateErrorCount() {
		this.errorCount = 0;
		console.log(this.devices)
		this.devices.forEach(device => {
			const modules = device.data?.Modules;
			if (modules) {
				for (let i = 0; i < modules.length; i++) {
					this.checkDataWarningError(modules[i]);
					if (modules[i].Features) {
						for (let j = 0; j < modules[i].Features.length; j++) {
							this.checkDataWarningError(modules[i].Features[j]);
						}
					}
				}
			}
		});
	}

	changeMailModule(data: ModuleVct): void {
		if (!this.isEmailValid(data.OwnerEmail)) {
			data.WarningError = true;
			data.WarningErrorType = 'VCT_MAIL_NOT_VALID';
			this.updateErrorCount();
		} else {
			data.WarningError = false;
			data.WarningErrorType = '';
			this.updateErrorCount();
		}
	}

	changeMailApp(data: FeatureVct): void {
		if (!this.isEmailValid(data.SipAccount.UserEmail)) {
			data.WarningError = true;
			data.WarningErrorType = 'VCT_MAIL_NOT_VALID';
			this.updateErrorCount();
		} else {
			data.WarningError = false;
			data.WarningErrorType = '';
			this.updateErrorCount();
		}
	}

	isEmailValid(email: string): boolean {
		if (email === '') {
			return true;
		}
		const re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
		return re.test(email.toLowerCase());
	}

	get f(): any {
		return this.deviceFilters.controls;
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	actionLayout(position: string): string {
		return StandardMtmaLayout.actionLayout(this.screenWidth, position);
	}

	getSplitString(str: string): string {
		return StandardTruncateString.getSplitString(this.screenWidth, str, 15, 50, 100);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-26rem');
	}

	dynamicInputTextDesktopTabletWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-26rem', 'w-20rem');
	}

}
